import moment from "moment";
import { IoIosArrowDropleft, IoIosArrowDropright } from "react-icons/io";

const DateChangeComponent = ({
  handleDateChange,
  date,
}: {
  handleDateChange: CallableFunction;
  date: string | number;
}) => {
  return (
    <div className="d-flex align-items-center justify-content-center fs-20 fw-600 text-grey-500">
      <IoIosArrowDropleft
        size={32}
        className="cursor-pointer"
        onClick={() => {
          handleDateChange("subtract");
        }}
      />
      <span className="mx-2">{moment(date).format("DD MMM")}</span>
      <IoIosArrowDropright
        size={32}
        className="cursor-pointer"
        onClick={() => {
          handleDateChange("add");
        }}
      />
    </div>
  );
};

export default DateChangeComponent;
